var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRedirect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4442_30591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4442_30591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bubble",
    d: "M8.00016 2.83301C8.77961 2.83301 9.51294 2.98173 10.2002 3.27917C10.8874 3.57662 11.4882 3.98262 12.0027 4.49717C12.5172 5.01162 12.9232 5.61245 13.2207 6.29967C13.5181 6.9869 13.6668 7.72023 13.6668 8.49967C13.6668 9.27912 13.5181 10.0125 13.2207 10.6997C12.9232 11.3869 12.5172 11.9877 12.0027 12.5022C11.4882 13.0167 10.8874 13.4227 10.2002 13.7202C9.51294 14.0176 8.77961 14.1663 8.00016 14.1663C7.57027 14.1663 7.14527 14.1174 6.72516 14.0195C6.30505 13.9216 5.89889 13.7782 5.50666 13.5893L6.26683 12.8292C6.53516 12.9394 6.81911 13.0232 7.11866 13.0805C7.41833 13.1377 7.71216 13.1663 8.00016 13.1663C9.28905 13.1663 10.3891 12.7108 11.3002 11.7997C12.2113 10.8886 12.6668 9.78856 12.6668 8.49967C12.6668 7.21079 12.2113 6.11079 11.3002 5.19967C10.3891 4.28856 9.28905 3.83301 8.00016 3.83301C6.71127 3.83301 5.61127 4.28856 4.70016 5.19967C3.78905 6.11079 3.3335 7.21079 3.3335 8.49967C3.3335 8.80056 3.36105 9.09329 3.41616 9.37784C3.47127 9.66251 3.55611 9.94545 3.67066 10.2267L2.92066 10.9765C2.725 10.6022 2.57822 10.2033 2.48033 9.77984C2.38244 9.35629 2.3335 8.92956 2.3335 8.49967C2.3335 7.72023 2.48222 6.9869 2.77966 6.29967C3.07711 5.61245 3.48311 5.01162 3.99766 4.49717C4.51211 3.98262 5.11294 3.57662 5.80016 3.27917C6.48738 2.98173 7.22072 2.83301 8.00016 2.83301ZM8.8335 10.9997V8.36884L3.06166 14.1407L2.35916 13.4382L8.131 7.66634H5.50016V6.66634H9.8335V10.9997H8.8335Z",
    fill: "#194893"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedirect);
export default __webpack_public_path__ + "static/media/icon-redirect.247063a79bc0c4e80861785b285e45dd.svg";
export { ForwardRef as ReactComponent };